$(function() {
  'use strict';

  var $scrolls = $('.js-scroll');

  $scrolls.each(function (index, container) {
    var $container = $(container),
        $button = $container.find('.js-scroll-button'),
        buttonCenter = {
          'x': $button.outerWidth() / 2,
          'y': $button.outerHeight() / 2
        };

    $button.on('click', function(event) {
      event.preventDefault();
      event.stopPropagation();

      $('html, body').animate({
        scrollTop: $($button.attr('href')).offset().top
      }, 800);
    });

    $container.on('mousemove', function(event) {
      if(!Modernizr.touchevents) {

        var $target = $(event.target),
            is_link = event.target.hasAttribute('href'),
            has_link = $target.parents('[href]').length > 0;

        if(is_link || has_link) {
          $button.css({
            display: 'none'
          });
        } else {
          $button.css({
            left: event.pageX - $container.offset().left - buttonCenter.x,
            top: event.pageY - $container.offset().top - buttonCenter.y,
            bottom: 'auto',
            display: ''
          });
        }
      }
    });

    $container.on('click', function(event) {
      if(!Modernizr.touchevents) {
        var $target = $(event.target),
            is_link = event.target.hasAttribute('href'),
            has_link = $target.parents('[href]').length > 0;

        if(!is_link && !has_link) {
          $button.trigger('click');
        }
      }
    });

    $container.hover(function(event) {
      $button.addClass('is-moving');
    }, function(event) {
      $button.removeClass('is-moving');
    });
  });
});
